import { ReactNode, useReducer } from 'react';
import { FiltersStateContext, FiltersDispatchContext, getDefaultFilterState } from './FiltersContext';
import { filtersReducer } from './FiltersContext.reducer';
import { IFiltersState } from './FiltersContext.types';
function getOpenAccordionsFromLocalStorage() {
  const storedState = window.localStorage && window.localStorage.getItem('insync-student-lib-openAccordions');
  return new Set(storedState ? JSON.parse(storedState) : []);
}
interface FiltersContextProviderProps {
  children: ReactNode;
  initialState?: Partial<IFiltersState>;
}
export function FiltersContextProvider({
  children,
  initialState = {}
}: FiltersContextProviderProps) {
  const [state, dispatchContext] = useReducer(filtersReducer, {
    ...getDefaultFilterState(),
    openAccordions: getOpenAccordionsFromLocalStorage(),
    ...initialState
  });
  return <FiltersStateContext.Provider value={state}>
      <FiltersDispatchContext.Provider value={dispatchContext}>
        {children}
      </FiltersDispatchContext.Provider>
    </FiltersStateContext.Provider>;
}